export default {"src":"/_next/static/media/treenut.5227ba02.svg","height":20,"width":15,"blurWidth":0,"blurHeight":0};